import React, { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
} from "chart.js";
import "./TrendChart.css";
import axiosInstance from "../../axiosInstance";
import EmptyState from "../common/EmptyState";

// Register necessary Chart.js components
ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend
);

const TrendChart: React.FC = () => {
  const [trendData, setTrendData] = useState<{
    labels: string[];
    values: number[];
  }>({
    labels: [],
    values: [],
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTrend = async () => {
      try {
        const res = await axiosInstance.get("/analytics/dashboard/venture");
        const ordersByDate = res.data?.data?.charts?.orders_by_date || [];
        const labels = ordersByDate.map((item: any) =>
          new Date(item.date).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
          })
        );
        const values = ordersByDate.map((item: any) =>
          Number(item.total_orders)
        );
        setTrendData({ labels, values });
      } catch (error) {
        setTrendData({ labels: [], values: [] });
      } finally {
        setLoading(false);
      }
    };
    fetchTrend();
  }, []);

  const data = {
    labels: trendData.labels,
    datasets: [
      {
        label: "Count of Orders",
        data: trendData.values,
        borderColor: "#4CAF50",
        fill: true,
        backgroundColor: "rgba(76, 175, 80, 0.2)",
        tension: 0.4, // Adds a smooth curve
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false, // Ensures the chart can resize properly
    plugins: {
      legend: { display: false }, // Hides the legend
    },
    scales: {
      x: {
        grid: {
          display: false, // Hides grid lines on x-axis
        },
      },
      y: {
        beginAtZero: true, // Ensures y-axis starts at 0
        ticks: {
          stepSize: 1, // Custom step size
        },
      },
    },
  };

  return (
    <div className="trend-chart-container">
      <h3 className="trend-chart-title">Daily order trend</h3>
      <div style={{ minHeight: 220, position: "relative", display: "flex", alignItems: "center", justifyContent: "center" }}>
        {loading ? (
          <div className="trend-chart-loading">Loading...</div>
        ) : trendData.labels.length === 0 ? (
          <EmptyState
            title="No trend data available"
            description="There is no trend data to display yet."
          />
        ) : (
          <Line data={data} options={options} />
        )}
      </div>
    </div>
  );
};

export default TrendChart;
